export const CASE_ID_PATTERN_SOURCE = 'CIM-\\d+';
export const CASE_URL_BASE = 'https://scope.pondurance.com/case/';
